import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  const handleCTAClick = (label) => {
    handleLinkClick();
    try {
      if (window.gtag) {
        window.gtag('event', 'cta_click', { label });
      }
    } catch (e) { }
  };

  return (
    <>
      {/* Mobile Overlay */}
      <div
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
        <nav className="container nav-container">
          <a href="#top" className="brand" onClick={handleLinkClick}>
            <span className="brand-text-modern">Upgrace.in</span>
          </a>

          {/* Desktop Menu */}
          <ul className="desktop-menu">
            <li><a href="#services" className="nav-link-modern">Services</a></li>
            <li><a href="#work" className="nav-link-modern">Work</a></li>
            <li><a href="#testimonials" className="nav-link-modern">Testimonials</a></li>
            <li><a href="#contact" className="nav-link-modern">Contact</a></li>
            <li>
              <a href="#contact" className="btn btn-sm btn-primary" onClick={() => handleCTAClick('Navbar CTA')}>
                Get Proposal
              </a>
            </li>
          </ul>

          {/* Mobile Toggle */}
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </nav>
      </header>

      {/* Mobile Menu Content */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-links">
          <li><a href="#services" className="nav-link-modern" onClick={handleLinkClick}>Services</a></li>
          <li><a href="#work" className="nav-link-modern" onClick={handleLinkClick}>Work</a></li>
          <li><a href="#testimonials" className="nav-link-modern" onClick={handleLinkClick}>Testimonials</a></li>
          <li><a href="#contact" className="nav-link-modern" onClick={handleLinkClick}>Contact</a></li>
          <li>
            <a href="#contact" className="btn btn-primary" onClick={() => handleCTAClick('Mobile Menu CTA')}>
              Get Proposal
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
